<nz-card nzType="inner" nzSize="small" [nzTitle]="panelTitle" class="display-panel-box">
  <ng-content select="[body]"></ng-content>
</nz-card>
<ng-template #panelTitle>
  <ng-content select="[header]"></ng-content>
</ng-template>
